import React from "react";
import { makeStyles } from "@mui/styles";
import { Container, Typography, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { theme } from "../styles/theme";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  title: {
    flexGrow: 1,
    color: theme.palette.btnPrimary.tertiaryText,
    cursor: "pointer",

    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  linkunderline: {
    "& .css-1ps4owl-MuiTypography-root-MuiLink-root": {
      textDecoration: "none !important",
    },
  },
  container: {
    paddingLeft: "16px",
    paddingRight: "16px",
    // paddingBottom: "50px"
    // [theme.breakpoints.up("tablet")]: {
    //   paddingLeft: "64px",
    //   paddingRight: "64px",
    // },
  },
  footer: {
    backgroundColor: theme.palette.primary.light,
    [theme.breakpoints.up("tablet")]: {
      height: 90,
      // position:'fixed',
      bottom: "0px",
      width: "100% !important",
      //right:'0px'
    },
  },
  footerRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },
  footerLeftAlign: {
    // FK cleanup July 2023
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  floatRight: {
    //  float: "right",
    textAlign: "end",
  },
  floatLeft: {
    // FK cleanup July 2023
    float: "left",
  },
  aboutLeft: {
    // FK cleanup July 2023
    marginRight: "40px",
    [theme.breakpoints.down("sm")]: {
      margin: "24px auto 10px auto",
    },
  },
  divider: {
    margin: "0 10px",
    color: "#787878",
  },
  containerCls: {
    // FK cleanup July 2023
    paddingRight: "24px",
    paddingLeft: "24px",
    [theme.breakpoints.up("tablet")]: {
      paddingRight: "auto !important",
      paddingLeft: "64px !important",
    },
  },
  terms: {
    // FK cleanup July 2023
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px",
      marginTop: "33px",
    },
  },
  policy: {
    // FK cleanup July 2023
    marginBottom: "33px",
  },
  companyName: {
    // FK cleanup July 2023
    marginBottom: "24px",
  },
  footerLeftDrawer: {
    // FK cleanup July 2023
    position: "fixed",
    bottom: "48px",
    "& .MuiGrid-container": {
      justifyContent: "center",
    },
    "@media (orientation: landscape)": {
      position: "unset",
      marginBottom: "48px",
    },
  },
});

export default function Footer(props) {
  const { leftDrawer } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isNotMobile = useMediaQuery(theme.breakpoints.up("tablet"));
  const d = new Date();
  let year = d.getFullYear();
  const navigate = useNavigate();
  return (
    <div className={classes.footer}>
      {/* 
      // FK cleanup comments july 2023
      {leftDrawer && (
     <Container maxWidth="xl"  className={`${classes.footerLeftDrawer} ${classes.containerCls}`}>
     <Grid container className="Home-hero">
       <Grid item >
         <div className={classes.footerLeftAlign}>
               <Link onClick={() => history.push("/FAQ")} data-rt-div-faq = "faqlink">
                 <Typography variant="body2" className={classes.title}>
                   FAQ
                 </Typography>
               </Link>
               <b className={classes.divider}>|</b>
         </div>
       </Grid>
       <Grid item >
           <div className={classes.footerRight}>
             <Link onClick={() => history.push("/Terms&Conditions")} data-rt-div-tc = "tclink">
               <Typography variant="body2" className={classes.title}>
                 Terms & Conditions
               </Typography>
             </Link>
         </div>
       </Grid>
       <Grid item >
           <div className={classes.footerRight}>
             <b className={classes.divider}>|</b>
             <Link onClick={() => history.push("/Privacypolicy")} data-rt-div-privacypolicy = "privacypolicylink">
               <Typography variant="body2" className={classes.title}>
               Privacy Policy
               </Typography>
             </Link>
         </div>
       </Grid>
     </Grid>
   </Container>
      )} */}

      {isNotMobile && !leftDrawer && (
        <Container maxWidth="xl" className={classes.container}>
          <Grid container style={{ paddingTop: "15px" }}>
            <Grid item xs={3}></Grid>
            <Grid item xs={5}></Grid>
            <Grid item xs={4}>
              <div className={classes.footerRight}>
                <Grid
                  onClick={() => navigate("/terms&conditions")}
                  data-rt-div-tc="tclink"
                  className={classes.linkunderline}
                >
                  <Typography variant="body2" className={classes.title}>
                    Terms & Conditions
                  </Typography>
                </Grid>
                <b className={classes.divider}>|</b>
                <Grid
                  onClick={() => navigate("/privacypolicy")}
                  data-rt-div-privacypolicy="privacypolicylink"
                  className={classes.linkunderline}
                >
                  <Typography variant="body2" className={classes.title}>
                    Privacy Policy
                  </Typography>
                </Grid>
              </div>
              <div className={classes.company}>
                <Typography variant="body2" className={`${classes.title} ${classes.floatRight}`}>
                  Copyright &copy;{year} TechScore. All Rights Reserved.
                </Typography>
              </div>
              {/* </div> */}
            </Grid>
          </Grid>
        </Container>
      )}

      {!isNotMobile && !leftDrawer && (
        <Container maxWidth="xl" className={classes.container}>
          <Grid container className="Home-hero" style={{ paddingTop: "15px", display: "flex", justifyContent: "end" }}>
            <Grid item>
              <Grid
                onClick={() => navigate("/terms&conditions")}
                data-rt-div-tc="tclink"
                className={classes.linkunderline}
              >
                <Typography variant="body2" className={classes.title}>
                  Terms & Conditions
                </Typography>
              </Grid>
            </Grid>
            <b className={classes.divider}>|</b>
            <Grid item>
              <Grid
                onClick={() => navigate("/privacypolicy")}
                data-rt-div-privacypolicy="privacypolicylink"
                className={classes.linkunderline}
              >
                <Typography variant="body2" className={classes.title}>
                  Privacy Policy
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography style={{ display: "flex", justifyContent: "end" }} variant="body2" className={classes.title}>
                Copyright &copy;{year} TechScore. All Rights Reserved.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      )}
    </div>
  );
}
